<template>
  <v-container py-0>
    <v-progress-linear
      :active="loading"
      height="3"
      :indeterminate="true"
      class="my-1"
    />
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout wrap row>
          <v-flex md6 xs12 px-2>
            <v-menu
              ref="menu"
              v-model="menuDate"
              :close-on-content-click="false"
              :nudge-right="40"
              full-width
              lazy
              min-width="290px"
              offset-y
              transition="scale-transition"
            >
              <v-text-field
                slot="activator"
                v-model="date"
                v-validate="'required'"
                :label="$t('fields.global.date') + ' (*)'"
                prepend-icon="event"
                readonly
                :data-vv-name="$tc('fields.global.date')"
                :error-messages="errors.collect($tc('fields.global.date'))"
              />
              <v-date-picker
                v-model="localTraining.date"
                first-day-of-week="1"
                :locale="$store.state.languages.iso()"
                :readonly="localTraining.started"
                @input="menuDate = false"
              />
            </v-menu>
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-menu
              ref="menuTime"
              v-model="menuTime"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="localTraining.time"
                  v-validate="'required'"
                  prepend-icon="access_time"
                  readonly
                  :label="$tc('fields.global.time')"
                  :data-vv-name="$tc('fields.global.time')"
                  :error-messages="errors.collect($tc('fields.global.time'))"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menuTime"
                v-model="localTraining.time"
                full-width
                :readonly="localTraining.started"
                @input="onChangeTime"
                @click:minute="$refs.menuTime.save(localTraining.time)"
              />
            </v-menu>
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="localTraining.name"
              v-validate="'required'"
              :label="$t('fields.global.name') + ' (*)'"
              :data-vv-name="$tc('fields.global.name')"
              :error-messages="errors.collect($tc('fields.global.name'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-textarea
              v-model="localTraining.description"
              :label="$t('titles.roles.description')"
              counter
              rows="3"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <team-field
              v-model="localTraining.teamId"
              v-validate="'required'"
              :label="
                $t('action.actions.select', { field: $tc('models.team') }) +
                ' (*)'
              "
              :data-vv-name="$tc('models.team')"
              :error-messages="errors.collect($tc('models.team'))"
              :readonly="
                localTraining.started || localTraining.streamingStarted
              "
              @change="$emit('changeTeam', localTraining.teamId)"
            />
          </v-flex>
          <v-flex md4 xs12 px-2>
            <pitch-field
              v-model="localTraining.location"
              v-validate="{
                required:
                  !!localTraining.recording ||
                  !!localTraining.streamingAndRecording,
              }"
              :team-id="localTraining.teamId"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.location'),
                })
              "
              :disabled="!localTraining.teamId"
              :data-vv-name="$tc('fields.global.location')"
              :error-messages="errors.collect($tc('fields.global.location'))"
              :readonly="localTraining.streamingStarted"
              :clearable="!localTraining.streamingStarted"
            />
          </v-flex>
          <v-flex md2 xs12 px-2>
            <v-text-field
              v-model="localTraining.trainingDuration"
              v-validate="'numeric'"
              type="number"
              :label="$tc('fields.trainings.trainingDuration')"
              :data-vv-name="$tc('fields.trainings.trainingDuration')"
              :error-messages="
                errors.collect($tc('fields.trainings.trainingDuration'))
              "
              :readonly="localTraining.streamingStarted"
            />
          </v-flex>
          <v-flex md3 xs6 px-2>
            <v-radio-group
              v-model="streamingType"
              :readonly="localTraining.streamingStarted"
            >
              <v-radio
                :label="$t('titles.matches.noRecord')"
                color="primary"
                value="noRecord"
              />
              <v-radio
                :label="$t('fields.trainings.recording')"
                color="primary"
                value="recording"
              />
              <v-radio
                :label="$t('fields.trainings.streamingAndRecording')"
                color="primary"
                value="streamingAndRecording"
              />
            </v-radio-group>
            <!-- <v-switch
              v-model="localTraining.recording"
              :label="$t('fields.matches.recording')"
              color="primary"
            ></v-switch>-->
          </v-flex>
          <template
            v-if="
              localTraining.streamingAndRecording || localTraining.recording
            "
          >
            <v-flex md3 xs6 px-2>
              <v-switch
                v-model="localTraining.autoStreaming"
                :label="$t('fields.matches.autoStreaming')"
                color="primary"
                :readonly="localTraining.streamingStarted"
                @change="onChangeAutoStreaming"
              />
            </v-flex>
            <v-flex v-if="localTraining.autoStreaming" md3 sm6 xs12 px-2>
              <v-menu
                ref="menuAutoStreaming"
                v-model="menuAutoStreaming"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    ref="timeAutoStreaming"
                    v-model="localTraining.timeAutoStreaming"
                    prepend-icon="access_time"
                    readonly
                    :label="$tc('fields.matches.dateAutoStreaming')"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuAutoStreaming"
                  v-model="localTraining.timeAutoStreaming"
                  full-width
                  :readonly="localTraining.streamingStarted"
                  @input="saveTimeAutoStreaming"
                />
              </v-menu>
            </v-flex>
          </template>
          <v-flex v-if="localTraining.broadcastId" md3 xs12 px-2>
            <v-text-field
              v-model="localTraining.broadcastId"
              readonly
              :label="$tc('fields.matches.broadcastId')"
            />
          </v-flex>
          <v-flex md3 xs6 px-2>
            <v-switch
              v-model="localTraining.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
          <v-flex v-if="isAdmin" md3 xs6 px-2>
            <v-switch
              v-model="localTraining.emissionStatus"
              :label="$t('fields.trainings.emissionStatus')"
              color="primary"
            />
          </v-flex>
          <v-flex md3 xs6 px-2>
            <v-switch
              v-if="!localTraining.relTrainingId"
              v-model="localTraining.repeatWeekly"
              :label="$t('fields.matches.repeatWeekly')"
              color="primary"
            />
            <v-switch
              v-else
              :input-value="true"
              readonly
              :label="$t('fields.matches.repeatWeekly')"
              color="primary"
            />
          </v-flex>
          <v-flex v-if="localTraining._id" xs12>
            <v-layout row wrap>
              <v-flex
                v-if="!localTraining.started && !localTraining.ended"
                md3
                xs6
                px-2
              >
                <button-confirm
                  color="primary"
                  :text="$t('action.buttons.startTraining')"
                  :disabled="loading"
                  @submit="startTraining(localTraining._id)"
                />
              </v-flex>
              <v-flex
                v-else-if="localTraining.started && !localTraining.ended"
                md3
                xs6
                px-2
              >
                <button-confirm
                  color="error"
                  :text="$t('action.buttons.endTraining')"
                  :disabled="loading"
                  @submit="endTraining(localTraining._id)"
                />
              </v-flex>
              <template
                v-if="selected.streamingAndRecording || selected.recording"
              >
                <v-flex
                  v-if="
                    !!selected.location &&
                    !localTraining.streamingStarted &&
                    !localTraining.ended
                  "
                  md3
                  xs6
                  px-2
                >
                  <button-confirm
                    color="primary"
                    :text="$t('action.buttons.startStreaming')"
                    :disabled="loading"
                    @submit="
                      ifStartStreaming(
                        localTraining._id,
                        localTraining.location
                      )
                    "
                  />
                </v-flex>
                <v-flex
                  v-else-if="
                    localTraining.streamingStarted &&
                    !localTraining.streamingEnded &&
                    localTraining.ended
                  "
                  md3
                  xs6
                  px-2
                >
                  <button-confirm
                    color="error"
                    :text="$t('action.buttons.endStreaming')"
                    :disabled="loading"
                    @submit="endStreaming(localTraining._id)"
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
          <v-flex v-if="localTraining._id && localTraining.ended" md3 xs6 px-2>
            <v-btn class="blue" dark @click="dialogUpload = true">
              {{
                $t('action.actions.upload', {
                  field: $t('fields.matches.video'),
                })
              }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <dialog-confirm-streaming
      ref="confirmStreaming"
      :text="confirmStreamingMessage"
      @submit="startStreaming(localTraining._id)"
    />
    <dialog-time-difference
      ref="timeDifference"
      type="training"
      :time="localTraining.time"
      :time-auto-streaming="localTraining.timeAutoStreaming"
      @submit="onSubmitTimeDifference"
      @cancel="onCancelTimeDifference"
    />
    <dialog-upload-video
      v-model="dialogUpload"
      :object-id="localTraining._id"
      :video-exist="video"
      type-video="training"
      @upload="onUploadVideo"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import PitchField from '@/components/widgets/Input/PitchField'
import TeamField from '@/components/widgets/Input/TeamField'
import ButtonConfirm from '@/components/widgets/button/ButtonConfirm'
import DialogConfirm from '@/components/widgets/dialog/DialogConfirm'
import DialogTimeDifference from '@/components/widgets/dialog/DialogTimeDifference'
import DialogUploadVideo from '@/components/widgets/dialog/DialogUploadVideo'
import { formatDate } from '@/helpers'
export default {
  name: 'TabInformation',
  components: {
    DialogUploadVideo,
    TeamField,
    PitchField,
    ButtonConfirm,
    DialogConfirmStreaming: DialogConfirm,
    DialogTimeDifference,
  },
  props: {
    training: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      menuDate: false,
      menuTime: false,
      menuAutoStreaming: false,
      streamingType: 'noRecord',
      confirmStreamingMessage: '',
      dialogUpload: false,
      matchesDuration: 90,
      previousTimeDifference: null,
      syncingTimeAutoStreaming: false,
    }
  },
  computed: {
    ...mapState({
      selected: (state) => state.trainings.selected,
      loading: (state) => state.trainings.loading,
      video: (state) => state.trainings.video,
    }),
    localTraining: {
      get() {
        return this.training
      },
      set(value) {
        this.$emit('update:training', value)
      },
    },
    date() {
      return formatDate(this.localTraining.date)
    },
    dateAutoStreaming() {
      return formatDate(this.localTraining.dateAutoStreaming)
    },
  },
  watch: {
    menuAutoStreaming(val) {
      if (!val) return

      this.previousTimeDifference = {
        timeAutoStreaming: this.localTraining.timeAutoStreaming,
      }
    },
    streamingType(val) {
      if (val === 'recording') {
        this.localTraining.recording = true
        this.localTraining.streamingAndRecording = false
      } else if (val === 'streamingAndRecording') {
        this.localTraining.recording = false
        this.localTraining.streamingAndRecording = true
      } else if (val === 'noRecord') {
        this.localTraining.recording = false
        this.localTraining.autoStreaming = false
        this.localTraining.streamingAndRecording = false
      }
    },
    'localTraining.recording': {
      handler: 'setStreamingType',
      immediate: true,
      deep: true,
    },
    'localTraining.streamingAndRecording': {
      handler: 'setStreamingType',
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      endTraining: 'trainings/endTraining',
      startTraining: 'trainings/startTraining',
      startStreaming: 'trainings/startStreaming',
      endStreaming: 'trainings/endStreaming',
      isCameraInUse: 'pitches/isCameraInUse',
    }),
    clear() {
      this.$validator.reset()
      this.streamingType = 'noRecord'
    },
    getDefaultTimeAutoStreaming(time) {
      if (!time) return null

      return moment(time, 'HH:mm').subtract(5, 'minutes').format('HH:mm')
    },
    onChangeTime(time) {
      if (time && this.localTraining.autoStreaming) {
        this.syncingTimeAutoStreaming = true
        this.$nextTick(() => {
          const nextTimeAutoStreaming = this.getDefaultTimeAutoStreaming(time)

          this.localTraining.timeAutoStreaming = nextTimeAutoStreaming
          if (this.$refs.timeAutoStreaming) {
            this.$refs.timeAutoStreaming.lazyValue = nextTimeAutoStreaming
          }
          this.$nextTick(() => {
            this.syncingTimeAutoStreaming = false
          })
        })
      }
    },
    saveTimeAutoStreaming(time) {
      this.localTraining.timeAutoStreaming = time
      this.$refs.menuAutoStreaming.save(time)
      if (this.$refs.timeAutoStreaming) {
        this.$refs.timeAutoStreaming.lazyValue = time
      }
      this.$nextTick(() => {
        this.$refs.timeDifference.checkTimeDifference(
          this.localTraining.time,
          time
        )
      })
    },
    onSubmitTimeDifference() {
      this.previousTimeDifference = null
    },
    onCancelTimeDifference() {
      const nextTimeAutoStreaming = this.getDefaultTimeAutoStreaming(
        this.localTraining.time
      )

      // Previous behavior restored the value present before editing
      // timeAutoStreaming.
      // if (!this.previousTimeDifference) return
      // this.localTraining.timeAutoStreaming =
      //   this.previousTimeDifference.timeAutoStreaming

      if (!nextTimeAutoStreaming) {
        this.previousTimeDifference = null
        return
      }

      this.localTraining.timeAutoStreaming = nextTimeAutoStreaming

      if (this.$refs.timeAutoStreaming) {
        this.$refs.timeAutoStreaming.lazyValue = nextTimeAutoStreaming
      }

      this.previousTimeDifference = null
    },
    onChangeAutoStreaming(autoStreaming) {
      if (autoStreaming) {
        this.streamingType = 'streamingAndRecording'
        this.$nextTick(() => {
          this.onChangeTime(this.localTraining.time)
        })
      } else {
        this.localTraining.dateAutoStreaming = null
        this.localTraining.timeAutoStreaming = null
      }
    },
    onUploadVideo() {
      this.$store.dispatch('trainings/fetchOne', this.localTraining._id)
    },
    setStreamingType() {
      if (this.localTraining.recording) {
        this.streamingType = 'recording'
      } else if (this.localTraining.streamingAndRecording) {
        this.streamingType = 'streamingAndRecording'
      } else {
        this.streamingType = 'noRecord'
      }
    },
    ifStartStreaming(matchId, pitchId) {
      this.isCameraInUse(pitchId)
        .then(({ status, inUse }) => {
          this.confirmStreamingMessage = ''
          if (status === false) {
            this.confirmStreamingMessage =
              this.$t('titles.global.cameraOffline') + ' '
          } else if (inUse) {
            this.confirmStreamingMessage =
              this.$t('titles.global.cameraInUse') + ' '
          }
          if (this.confirmStreamingMessage) {
            this.confirmStreamingMessage += this.$t(
              'titles.global.confirmMessage',
              {
                field:
                  `<span class="text-uppercase primary--text">` +
                  this.$t('action.buttons.startStreaming') +
                  '</span>',
              }
            )
            this.$refs.confirmStreaming.show()
          } else {
            this.startStreaming(matchId)
          }
        })
        .catch(() => {
          this.startStreaming(matchId)
        })
    },
  },
}
</script>
